module.exports = __webpack_public_path__ + "0706bed3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/angle-gray.svg
// module id = 1933
// module chunks = 15 17 21 32 36